import kinetikApi from './kinetikAPI';

export default {
  getGeocode: (options) =>
    kinetikApi
      .get('/proxy/google-maps/geocode/json', {
        ...options,
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  getAutoComplete: (options) =>
    kinetikApi
      .get(`/proxy/google-maps/place/autocomplete/json`, {
        ...options,
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  getGeocodeFromPlaceID: (placeID) =>
    kinetikApi
      .get(`/proxy/google-maps/geocode/json?place_id=${placeID}`, {
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  getDistance: (options) =>
    kinetikApi
      .get(`/proxy/google-maps/distancematrix/json`, {
        ...options,
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  getPublicTransportRoute: (options) =>
    kinetikApi
      .get('/proxy/google-maps/directions/json', {
        ...options,
        serviceName: 'proxy',
      })
      .then((res) => res.data),
};
